import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { Creators as Actions, Types } from "ducks/Empresa";
import { Creators as ActionsGeral } from "ducks/Geral";
import api from "../api/api";
import notify from 'utils/modern_notify';

const criarEmpresaRequisicao = async (parametro_empresa) =>
    api
        .post("/api/grupo/empresa/cadastrar", parametro_empresa)
        .then((dados) => dados)
        .catch((error) => error);

const adicionarBaseRequisicao = async (parametro_base) =>
    api
        .put("/api/grupo/empresa/criarBases", parametro_base)
        .then((dados) => dados)
        .catch((error) => error);

const editarBaseRequisicao = async (dados) =>
    api
        .put("api/grupo/empresa/editarBases", dados)
        .then((dados) => dados)
        .catch((error) => error);

const listarBaseRequisicao = async (dados) =>
    api
        .get("api/empresa/listar/" + dados)
        .then((dados) => dados)
        .catch((error) => error);

const removerBaseRequisicao = async (dados) =>
    api
        .delete("/api/grupo/empresa/removerBases/", dados)
        .then((dados) => dados)
        .catch((error) => error);

const getGruposReq = async (parametro_empresa) =>
    api
        .get("/api/grupo/empresa/listar", parametro_empresa)
        .then((dados) => dados)
        .catch((error) => error);

function* criarEmpresa({ payload }) {
    const { formCriar } = payload;

    let modulosActive = {};
    let parametro_empresa = {};
    let dados_grupo = {
        [formCriar.name]: {
            cnpj: formCriar.cnpj,
            endereco:
                formCriar.rua +
                ", " +
                formCriar.numero +
                " " +
                formCriar.bairro +
                " - " +
                formCriar.cidade +
                ", " +
                formCriar.estado,
            telefone: formCriar.phone,
            tipo_empresa: formCriar.new_empresa_tipo,
            ficticio: false,
        },
    };

    let responseData = [];

    let bases_grupo = [formCriar.name];
    let cnpjs_grupo = [formCriar.cnpj];

    const modules = formCriar.models;
    for (let module in modules) {
        let obj = modules[module];
        modulosActive[obj.value] = {
            check: obj.check,
        };
    }

    const bases = formCriar.bases.bases;
    for (let base in bases) {
        let obj = bases[base];
        dados_grupo[obj.name] = {
            cnpj: obj.cnpj,
            endereco:
                obj.rua +
                ", " +
                obj.numero +
                " " +
                obj.bairro +
                " - " +
                obj.cidade +
                ", " +
                obj.estado,
            ficticio: obj.ficticio,
            telefone: obj.phone,
            tipo_empresa: formCriar.tipo_empresa,
        };
        bases_grupo.push(obj.name);
        cnpjs_grupo.push(obj.cnpj);
    }

    try {
        let response = "";

        parametro_empresa = {
            nome_grupo: formCriar.nome_grupo ? formCriar.nome_grupo : "",
            tipo_grupo: formCriar.new_empresa_tipo,
            dados_grupo,

            bases_grupo,
            cnpjs_grupo,

            rota: modulosActive.rota ? modulosActive.rota.check : false,
            frete: modulosActive.frete ? modulosActive.frete.check : false,
            devolucao: modulosActive ? modulosActive.devolucao.check : false,
            fiscal: modulosActive.fiscal ? modulosActive.fiscal.check : false,
            dashboard: modulosActive.dashboard
                ? modulosActive.dashboard.check
                : false,
            cadastros: modulosActive.cadastros
                ? modulosActive.cadastros.check
                : false,
            romaneios: modulosActive.romaneios
                ? modulosActive.romaneios.check
                : false,
            protocolos: modulosActive.protocolos
                ? modulosActive.protocolos.check
                : false,
            pesquisar: modulosActive.pesquisar
                ? modulosActive.pesquisar.check
                : false,
            aplicativo: modulosActive.aplicativo
                ? modulosActive.aplicativo.check
                : false,
            auditoria: modulosActive.auditoria
                ? modulosActive.auditoria.check
                : false,
            rastreamento: modulosActive.rastreamento
                ? modulosActive.rastreamento.check
                : false,
            prazo: modulosActive.prazo ? modulosActive.prazo.check : false,
        };

        const isEmpty = Object.values(formCriar).some(
            (x) => x === undefined || x == null
        );
        if (isEmpty) {
            let pesqMens = "Existe campos obrigatorios não preenchidos";
            notify(pesqMens,1)
            // yield put(
            //     ActionsGeral.setMensagem({ mensagem: pesqMens, mostrar: true })
            // );
            return;
        } else if (modulosActive) {
            let modulosAtivos = [];
            for (let moduleObj in modulosActive) {
                let obj = modulosActive[moduleObj];
                if (obj.check === true) {
                    modulosAtivos.push(obj);
                }
            }

            if (modulosAtivos.length === 0) {
                let pesqMens =
                    "É necessário com que ao menos 1 módulo seja selecionado";
                notify(pesqMens,1)
            } else {
                response = yield call(
                    criarEmpresaRequisicao,
                    parametro_empresa
                );
            }
        } else {
            response = yield call(criarEmpresaRequisicao, parametro_empresa);
        }

        if (response.ok) {
            responseData = response.data;
            if (responseData.valor === undefined) {
                if (responseData.erro.codigo === "800") {
                    let pesqMens =
                        "Não foi encontrado CNPJ em uma de suas bases, por favor verificar.";
                    notify(pesqMens,1)
                } else if (responseData.erro.codigo === "801") {
                    let pesqMens = "Grupo já cadastrado";
                    notify(pesqMens,1)
                } else {
                    let pesqMens = responseData.erro;
                    notify(pesqMens)
                }
            } else {
                let pesqMens = responseData.valor.status;
                notify(pesqMens,1)
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default: {
                        console.log(response.data.error);
                        break;
                    }
                }
            }
        }
    } catch (err) {
        console.log("Algo saiu do esperado... " + err);
    }
}

function* adicionarBase({ payload }) {
    const { dados, grupo_emp, tipo_grupo } = payload;
    let dados_grupo = {};

    for (let base in dados) {
        let obj = dados[base];
        dados_grupo[obj.name] = {
            cnpj: obj.cnpj,
            endereco:
                obj.rua +
                ", " +
                obj.numero +
                " " +
                obj.bairro +
                " - " +
                obj.cidade +
                ", " +
                obj.estado,
            ficticio: obj.ficticio,
            telefone: obj.phone,
        };
    }

    try {
        let parametro_base = {
            dados_grupo,
            tipo_grupo,
            nome_grupo: grupo_emp,
        };

        yield put(Actions.setLoadAction({ exibir: true }));
        let response = yield call(adicionarBaseRequisicao, parametro_base);

        if (response.ok) {
            yield put(Actions.setLoadAction({ exibir: false }));
            yield put(Actions.adicionarBaseSuces({ ...dados_grupo }));
        }
    } catch (err) {
        console.log("Algo saiu do esperado " + err);
    }
}

function* listaBases({ payload }) {
    const { grupo_emp } = payload;

    try {
        yield put(Actions.setLoad({ exibir: true }));
        let response = yield call(listarBaseRequisicao, grupo_emp);

        if (response.ok) {
            yield put(Actions.listaBaseSuces(response.data));
        }
    } catch (err) {
        console.log(err);
    }
}

function* editarEmpresa({ payload }) {
    const { dados } = payload;
    let pesqMens = "";

    try {
        let editDados = {
            nome_grupo: dados.nome_grupo ? dados.nome_grupo : "",
            base: dados.new.base ? dados.new.base : "",
            cnpj: dados.new.cnpj_referencia
                ? dados.new.cnpj_referencia
                : dados.new.cnpj_empresa,
            endereco: dados.new.endereco ? dados.new.endereco : "",
            telefone: dados.new.telefone ? dados.new.telefone : "",
            anterior: {
                cnpj: dados.anterior.cnpj,
                base: dados.anterior.base,
            },
        };
        yield put(Actions.setLoad({ exibir: true }));

        let response = "";

        const isEmpty = Object.values(editDados).some((x) => x == "");
        if (!isEmpty) {
            response = yield call(editarBaseRequisicao, editDados);
        } else {
            pesqMens = "Há campos obrigatorios não preenchidos";
            notify(pesqMens,1)
            yield put(Actions.setLoad({ exibir: false }));
        }

        if (response.ok) {
            pesqMens = "Base atualizada com sucesso!";
            notify(pesqMens,2)
            yield put(Actions.setLoad({ exibir: false }));

            yield put(Actions.listaBases({ grupo_emp: dados.nome_grupo }));
        }
    } catch (err) {
        console.log(err);
    }
}

function* removeBase({ payload }) {
    const { dados } = payload;
    let pesqMens = "";

    try {
        let parametros = {
            cnpj: dados.cnpj,
            base: dados.base,
            nome_grupo: dados.nome_grupo,
        };

        let response = yield call(removerBaseRequisicao, parametros);

        if (response.ok) {
            yield put(Actions.removeBaseSuces({ index: dados.index }));
            pesqMens = "Base Excluida com sucesso";
            notify(pesqMens,2)
            yield put(Actions.setLoad({ exibir: false }));
        }
    } catch (err) {
        console.log(err);
    }
}

function* getGruposEmpresas({ payload }) {
    const { dados } = payload;
    let pesqMens = "";

    try {
        let parametros = {
            cnpj: dados.cnpj,
            base: dados.base,
            nome_grupo: dados.nome_grupo,
        };

        let response = yield call(getGruposReq, parametros);

        if (response.ok) {
            yield put(Actions.removeBaseSuces({ index: dados.index }));
            pesqMens = "Base Excluida com sucesso";
            notify(pesqMens,2)
            yield put(Actions.setLoad({ exibir: false }));
        }
    } catch (err) {
        console.log(err);
    }
}
export function* criarEmpresaDados() {
    yield takeLatest(Types.CRIAR_EMPRESA, criarEmpresa);
}

export function* adicionarBaseDados() {
    yield takeLatest(Types.ADICIONAR_BASE, adicionarBase);
}

export function* editarEmpresaDados() {
    yield takeLatest(Types.EDITAR_EMPRESA, editarEmpresa);
}

export function* listaBasesDados() {
    yield takeLatest(Types.LISTA_BASES, listaBases);
}

export function* removerBaseDados() {
    yield takeLatest(Types.REMOVE_BASE, removeBase);
}

export default function* rootSaga() {
    yield all([
        fork(criarEmpresaDados),
        fork(adicionarBaseDados),
        fork(editarEmpresaDados),
        fork(listaBasesDados),
        fork(removerBaseDados),
    ]);
}
